import { render, staticRenderFns } from "./ActionsView.vue?vue&type=template&id=38183edb&scoped=true&"
import script from "./ActionsView.vue?vue&type=script&lang=js&"
export * from "./ActionsView.vue?vue&type=script&lang=js&"
import style0 from "./ActionsView.vue?vue&type=style&index=0&id=38183edb&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "38183edb",
  null
  
)

export default component.exports